export const ResourceType = {
  RESOURCETWO: 'RESOURCETWO',
  EMPLOYEE: 'EMPLOYEE',
};
